module.exports = __webpack_public_path__ + "img/button_google.a358a73f.svg";